<template>
    <v-dialog v-model="model" :max-width="maxWidth" :persistent="persistent">
        <v-card class="rounded-xl elevation-12">
            <v-card-title :class="[titleColor, 'text--darken-3 font-weight-bold justify-center']">
                <v-icon v-if="!noIcon" left :color="iconColor">{{ icon }}</v-icon>
                {{ title }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="text-center py-6">
                <slot name="body"></slot>
            </v-card-text>
            <v-card-actions class="justify-end px-6 pb-4">
                <v-spacer></v-spacer>
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "RoundedDialog",
    props: {
        model: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'info'
        },
        iconType: {
            type: String,
            default: 'success'
        },
        persistent: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        maxWidth: {
            type: String,
            default: '600'
        },
        noIcon: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        titleColors: {
            success: 'green--text',
            error: 'red--text',
            warning: 'orange--text',
            info: 'blue--text'
        },
        icons: {
            success: 'mdi-check-circle',
            error: 'mdi-close-circle',
            warning: 'mdi-alert-circle',
            info: 'mdi-information-outline'
        },
        iconColors: {
            success: 'green',
            error: 'red',
            warning: 'orange',
            info: 'blue'
        }
    }),
    computed: {
        titleColor () {
            return this.titleColors[this.type];
        },
        icon () {
            return this.icons[this.iconType];
        },
        iconColor () {
            return this.iconColors[this.iconType];
        }
    }
}
</script>
